import(/* webpackMode: "eager" */ "/app/src/app/[locale]/not-found.tsx");
